export class TaskConflictException {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
} 
